import { defineMessages } from 'react-intl';

const messages = defineMessages({
  deactivateVendorHeader: {
    description: 'Modal Header Deactivate Vendor',
    defaultMessage: 'Deactivate {vendorName}',
    id: 'VdVTew',
  },
  errorBannerText: {
    description: 'Banner indicating an error occurred during the action',
    defaultMessage: 'An error occurred while attempting to deactivate the vendor. Please try again.',
    id: 'MAaIsK',
  },
  deactivateVendorModalBodyText: {
    description: 'Message warning user orders will be disrupted upon deactivating the vendor selected',
    defaultMessage: 'This action cannot be undone and will disrupt the workflow for any orders in <i>Awaiting Shipment</i> status.',
    id: 'O9RqAD',
  },
  deactivateButton: {
    description: 'Deactivate Account Button',
    defaultMessage: 'Deactivate Account',
    id: 'Cr3DU4',
  },
  cancelButton: {
    description: 'Cancel button',
    defaultMessage: 'Cancel',
    id: 'qz9XeG',
  },
});

export default messages;
